import request from '@/utils/request.js'

export function loginIn(data){
    return request({
        url: '/api/token/obtain/',
        method: 'post',
        data
    })
}

export function getMenu(data){
    return request({
        url:`api/gen/company/${data.id}/project_apps/`,
        method: 'get',
        data
    })
}